export default {
  "active": "_active_1remu_1",
  "fullscreen": "_fullscreen_1remu_11",
  "inactive": "_inactive_1remu_20"
};import "ni:sha-256;XHyBMSPbKSKwtKtjplPDMc1ASdy-xXU8h5dFy1X1kHk";